import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import _ from 'lodash';
import Text from 'components/base/Text';
import HideShowCopyTextField from 'components/HideShowCopyTextField/HideShowCopyTextField';
import { createCreateApiTokenModal } from 'modals/modal-options-factory';
import AppRouter from 'common/AppRouter';
import Button from '@material-ui/core/Button';
import { PmIncidentsSubTitleRadio } from '../index';
import { TokenTextWrapper } from '../pmIncidentsSettings.style';
import { isAdmin } from 'common/services/accounts.service';
import { Separator } from 'components/base/layout-components';

const getTokenPrefix = ({ api_token_id: apiTokenId, apiTokens }) => {
  const selectedToken = apiTokens.find(item => item.id === apiTokenId);
  return _.get(selectedToken, 'prefix', '');
};

const ApiTokenPmSettingIncidents = ({
  account,
  value,
  apiTokens,
  setApiTokens,
  toggleModal,
  toggleSnackBar,
  onTokenGenerated,
  tokenExists,
  isShowTokenField = false
}) => {
  const isAdminAccount = React.useMemo(() => isAdmin(account), [account]);
  const history = useHistory();
  const shouldShowToken = tokenExists && isShowTokenField && isAdminAccount;

  return (
    <>
      <Text lineHeight={1.7} size='medium' weight='bold'>
        API Integration
      </Text>
      <PmIncidentsSubTitleRadio
        text={'Incidents reported via API integration'}
      />
      {isShowTokenField &&
        ((tokenExists && (
          <HideShowCopyTextField
            initiallyVisible={false}
            showVisibilityToggle={false}
            showCopy={false}
            stringLength={32}
            hiddenCharacter='&middot;'
            hiddenPrefix={getTokenPrefix({
              api_token_id: _.get(value, 'api_token_id'),
              apiTokens
            })}
          />
        )) ||
          (isAdminAccount && (
            <Button
              data-testid='create-api-token-button'
              data-cy='create-api-token-button-data-cy'
              variant='contained'
              onClick={() => {
                toggleModal(
                  createCreateApiTokenModal({
                    showGoToSettingsMessage: true,
                    apiTokens,
                    toggleModal,
                    toggleSnackBar,
                    setApiTokens,
                    onTokenGenerated,
                    account,
                    onGoToSettingsClicked: () => {
                      toggleModal();
                      history.push(
                        `${AppRouter.API_TOKENS.path}?isOrgSettings=true`
                      );
                    },
                    onCancel: toggleModal
                  })
                );
              }}
            >
              Create API Token
            </Button>
          )))}
      {!!shouldShowToken && (
        <TokenTextWrapper>
          <Text data-testid='revoke-token-in-settings-label' size='medium'>
            to revoke a token go to{' '}
            <span
              data-testid='revoke-token-in-settings-label-clickable'
              onClick={() => {
                history.push(`${AppRouter.API_TOKENS.path}?isOrgSettings=true`);
              }}
            >
              settings / API tokens
            </span>
          </Text>
        </TokenTextWrapper>
      )}
      <Separator
        direction='horizontal'
        width='50%'
        height='1px'
        margin='2rem 0 1rem 0'
      />
    </>
  );
};

export default ApiTokenPmSettingIncidents;
